export interface IGetDeviceByIdentificationParamsDto {
    type: string;
    value: string;
}
